<template>
  <div v-if="!formulario">
    <div class="flex mb-6">
      <img class="mx-auto" src="@/assets/images/star.png" />
    </div>
    <div class="flex mb-6">
      <h1 class="mx-auto"><b>Vila Galé STAR</b></h1>
    </div>
    <div class="flex">
      <p class="mx-auto">{{$t('Houve_um_colega_que_se_destacou')}}</p>
    </div>
    <div class="flex">
      <p class="mx-auto">{{$t('Nomeia_o_para_o_Vila_Gale_Star')}}</p>
    </div>
    <div class="flex">
      <p class="mx-auto">
        <span class="mx-auto mobileCenter">{{$t('Todos_os_meses_e_eleito_um_vencedor')}}</span>
      </p>
    </div>
    <div class="flex mb-6">
      <p class="mx-auto">{{$t('Quem_sabe_se_tu_nao_seras_o_proximo')}}</p>
    </div>
    <div class="flex mb-6">
      <h4 class="mx-auto"><b>Vila Galé Star! {{$t('Faz_nos_Brilhar')}}</b></h4>
    </div>
    <div class="flex">
      <div class="mx-auto">
        <div class="inline-block">
          <vs-button
            class="ml-3"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-file-text"
            @click="popup = true"
            >{{$t('Regulamento')}}</vs-button
          >
        </div>
        <div class="inline-block">
          <vs-button
            class="ml-3"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-award"
            @click="goToForm()"
            >{{$t('Nomear')}}</vs-button
          >
        </div>
      </div>
    </div>
    <vs-popup title="Regulamento" :active.sync="popup">
      <p class="mb-3 siteColor"><b>1. {{$t('Finalidade')}}</b></p>
      <p class="mb-6">
        {{$t('O_programa_visa_evidenciar_o_merito_do_desempenho_dos')}}
      </p>

      <p class="mb-3 siteColor"><b>2. {{$t('Metodo')}}</b></p>
      <p class="mb-3">{{$t('O_programa_divide_se_em_4_fases')}}</p>

      <p class="mb-3" style="font-weight: bold">a) VG STAR {{$t('Mensal')}}</p>
      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('votacao')}}</b></li>
      </ul>
      <p class="mb-3">
        {{$t('a_votacao_doa_vg_star_mensal_e_feita_atraves_das')}}
      </p>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('eleicao')}}</b></li>
      </ul>
      <p class="mb-3">
        {{$t('a_eleicao_do_vg_star_mensal_e_feita_atraves_da')}}
      </p>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('premios')}}</b></li>
      </ul>
      <p>{{$t('ao_vencedor_do_vg_star_mensal_e_atribuido')}}</p>
      <ul style="list-style-type: disc" class="ml-5 mb-3">
        <ul style="list-style-type: disc" class="ml-5">
          <li class="ml-2">
            {{$t('o_premio_de_5000_em_vale_valor_ivla_gale_carregados')}}
          </li>
          <li class="ml-2">
            {{$t('sera_divulgadoa_oa_vencedora_atraves')}}
          </li>
        </ul>
      </ul>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('criterios_de_nao_eleicao')}}</b></li>
      </ul>
      <ul style="list-style-type: disc" class="ml-5 mb-3">
        <ul style="list-style-type: disc" class="ml-5">
          <li class="ml-2">{{$t('falta_injustificada_no_mes_da_nomeacao')}}</li>
          <li class="ml-2">{{$t('advertencia_por_escrito')}}</li>
          <li class="ml-2">{{$t('reclamacoes_com_o_seu_nome')}}</li>
          <li class="ml-2">{{$t('ter_sido_eleito_a_no_presente_trimestre')}}</li>
        </ul>
      </ul>

      <p class="mb-3" style="font-weight: bold">b) VG STAR {{$t('trimestral')}}</p>
      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('votacao')}}</b></li>
      </ul>
      <p class="mb-3">
        {{$t('oa_vg_star_trimestral_sera_uma_dosas_colegas')}}
      </p>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('eleicao')}}</b></li>
      </ul>
      <p class="mb-3">
        {{$t('a_eleicao_do_vg_star_trimestral_e_feita_atraves')}}
      </p>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('premios')}}</b></li>
      </ul>
      <p>{{$t('ao_vencedora_do_vg_star_trimestral_sao')}}</p>
      <ul style="list-style-type: disc" class="ml-5 mb-3">
        <ul style="list-style-type: disc" class="ml-5">
          <li class="ml-2">
            {{$t('em_vale_valor_carregados_no_profile_em_erp_50')}}
          </li>
          <li class="ml-2">
            {{$t('badge_com_estrela_que_devera_ser_utilizado_durante')}}
          </li>
          <li class="ml-2">
            {{$t('sera_divulgado_a_o_a_vencedor_a_para_os_clientes')}}
          </li>
        </ul>
      </ul>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('criterios_de_nao_eleicao')}}</b></li>
      </ul>
      <ul style="list-style-type: disc" class="ml-5 mb-3">
        <ul style="list-style-type: disc" class="ml-5">
          <li class="ml-2">{{$t('falta_injustificada_no_trimestre')}}</li>
          <li class="ml-2">{{$t('advertencia_por_escrito')}}</li>
          <li class="ml-2">{{$t('reclamacoes_com_o_seu_nome')}}</li>
          <li class="ml-2">{{$t('atrasos_injustificados_no_trimestre')}}</li>
          <li class="ml-2">{{$t('altercacoes')}}</li>
          <li class="ml-2">
            {{$t('ter_sido_nomeado_vg_star_trimestre_no_presente_ano')}}
          </li>
        </ul>
      </ul>

      <p class="mb-3" style="font-weight: bold">c) VG SUPERSTAR {{$t('hotel')}}</p>
      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('eleicao')}}</b></li>
      </ul>
      <p class="mb-3">
        {{$t('a_eleicao_do_vg_superstar_hotel_e_feita_atraves_de')}}
      </p>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('premios')}}</b></li>
      </ul>
      <p>{{$t('aoa_vencedora_do_vg_superstar_hotel_sao_atribuidos_os_premios')}}:</p>
      <ul style="list-style-type: disc" class="ml-5 mb-3">
        <ul style="list-style-type: disc" class="ml-5">
          <li class="ml-2">
            {{$t('em_vale_valor_carregados_no_profile_em_erp_100')}}
          </li>
          <li class="ml-2">
            {{$t('sera_divulgadoa_oa_vencedora_atraves_do_placard_do_ISL')}}
          </li>
        </ul>
      </ul>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('criterios_de_nao_eleicao')}}</b></li>
      </ul>
      <ul style="list-style-type: disc" class="ml-5 mb-3">
        <ul style="list-style-type: disc" class="ml-5">
          <li class="ml-2">{{$t('todas_os_criterios_referidos_no_vg_star')}}</li>
          <li class="ml-2">{{$t('nao_ter_sido_vencedora_do_vg_star')}}</li>
        </ul>
      </ul>

      <p class="mb-3" style="font-weight: bold">d) VG SUPERSTAR {{$t('nacional')}}</p>
      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('votacao')}}</b></li>
      </ul>
      <p class="mb-3">
        {{$t('oa_vg_superstar_nacional_e_feita_atraves_da_analise_dos')}}.
      </p>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('eleicao')}}</b></li>
      </ul>
      <p class="mb-3">
        {{$t('a_eleicao_do_vg_superstar_nacional_e_feita_por_um_juri')}}
      </p>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('premios')}}</b></li>
      </ul>
      <p>
        {{$t('ao_vencedor_do_vg_superstar_nacional_sao_atribuidos')}}
      </p>
      <ul style="list-style-type: disc" class="ml-5 mb-3">
        <ul style="list-style-type: disc" class="ml-5">
          <li class="ml-2">
            {{$t('em_vale_valor_carregados_no_profile_em_erp_200')}}
          </li>
          <li class="ml-2">
            {{$t('oa_vencedora_sera_convidadoa_a_estar_presente')}}
          </li>
          <li class="ml-2">
            {{$t('sera_divulgado_o_vencedor_para_os_clientes')}}
          </li>
        </ul>
      </ul>

      <ul style="list-style-type: disc" class="ml-5">
        <li class="ml-2"><b>{{$t('criterios_de_nao_eleicao')}}</b></li>
      </ul>
      <ul style="list-style-type: disc" class="ml-5 mb-3">
        <ul style="list-style-type: disc" class="ml-5">
          <li class="ml-2">{{$t('todas_os_criterios_referidos_no_vg_star')}}</li>
          <li class="ml-2">{{$t('nao_ter_sido_vencedor_a_do_vg_star')}}</li>
        </ul>
      </ul>
    </vs-popup>
  </div>
  <div v-else>
    <div class="w-full flex BotaoVoltar">
      <vs-button
        class="float-right mt-2"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-arrow-left"
        @click="formulario = false"
        >{{$t('returnButton')}}</vs-button
      >
    </div>
    <div class="w-full">
      <div class="w-full">
        <div class="lg:flex -mx-2">
          <div class="lg:w-1/3 px-2">
            <v-select
              class="vue-select w-full mt-6 block"
              v-model="category"
              :options="categories"
              label="label"
              :placeholder="$t('Categoria')"
              :filterable="false"
              @input="updateCategory"
              :clearable="false"
            >
            </v-select>
          </div>
          <div class="lg:w-1/3 px-2">
            <v-select
              class="vue-select w-full mt-6 block"
              v-model="year"
              :options="years"
              label="label"
              :placeholder="$t('Ano')"
              :filterable="false"
              @input="updateYear"
              :clearable="false"
            >
            </v-select>
          </div>
          <div
            id="section_quarter"
            v-if="section_quarter"
            class="lg:w-1/3 px-2"
          >
            <v-select
              class="vue-select w-full mt-6 block"
              v-model="quarter"
              :options="quarters"
              label="label"
              :placeholder="$t('Trimestre')"
              :filterable="false"
              :clearable="false"
              @input="updateQuarter"
            >
            </v-select>
          </div>
          <div id="section_month" v-if="section_month" class="lg:w-1/3 px-2">
            <v-select
              class="vue-select w-full mt-6 block"
              v-model="month"
              :options="months"
              label="label"
              :placeholder="$t('Mes')"
              :filterable="false"
              :clearable="false"
              @input="updateMonth"
            >
            </v-select>
          </div>
        </div>
        <div id="section_can_nominate" v-if="section_can_nominate">
          <div id="section_collaborator" class="flex -mx-2">
            <div class="w-full lg:w-1/2 px-2">
              <v-select
                class="vue-select w-full mt-6 block"
                v-model="collaborator"
                :reduce="(item) => item"
                :options="collaborators"
                label="nome"
                :placeholder="$t('Colaborador')"
                :filterable="false"
                :clearable="false"
                @search="onSearch"
              >
                <template slot="no-options">
                  <div v-if="goSearch.length >= 3 && found == 0">
                    {{$t('Nenhum_colaborador_encontrado')}}
                  </div>
                </template>
              </v-select>
            </div>
          </div>
          <vs-textarea
            class="w-full mt-6 block textarea"
            v-model="description"
            :placeholder="$t('Motivo')"
            counter="4000"
            :counter-danger.sync="counterDanger"
            rows="5"
          />
        </div>
        <div
          id="section_can_not_nominate"
          v-if="section_can_not_nominate"
          class="px-2 pt-10 w-full"
        >
          <vs-alert color="warning" icon-pack="feather" icon="icon-alert-triangle" class="mx-auto mt-3 w-full">
		     		<span>{{ section_can_not_nominate_message }}</span>
		   		</vs-alert>
        </div>
      </div>
      <div class="w-full flex">
        <vs-button
          @click="save()"
          class="mt-10 mx-auto"
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="icon-save"
          >{{$t('submit')}}</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { __translate } from "@/translate";

export default {
  data() {
    const currentYear = new Date().getFullYear();
    return {
      popup: false,
      formulario: false,
      collaborator: null,
      description: null,
      counterDanger: false,
      collaborators: [],
      goSearch: "",
      found: 0,
      category: null,
      year: {
        id: currentYear,
        label: currentYear,
      },
      quarter: null,
      month: null,
      categories: [],
      years: [],
      quarters: [],
      months: [],

      section_month: false,
      section_quarter: false,
      section_can_nominate: false,
      section_can_not_nominate: false,
      section_can_not_nominate_message: null,
    };
  },
  methods: {
    async init() {
      await this.getCategories();
      this.getYears();
    },
    async getCategories() {
      const hotelId =
        this.$user.staff_info.hvg_id == null
          ? null
          : this.$user.staff_info.hvg_id;
      this.$api({
        method: "get",
        url: "/human-resources/vg-star-category",
        headers: {
          Authorization: "Bearer " + this.$user.usertoken,
        },
        params: {
          hotel_id: hotelId,
          status: 1,
        },
      })
        .then((response) => {
          this.categories = response.data.map((item) => ({
            id: item.id,
            label: __translate(item.name),
            type_id: item.type_id,
          }));
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.notify(err.response.data.message, "red", 10);
          this.$vs.loading.close();
        });
    },
    getYears() {
      const currentYear = new Date().getFullYear();
      var years = [];
      years.push(currentYear);
      this.years = years.map((item) => ({
        id: item,
        label: item,
      }));
    },
    save() {
      if (!this.collaborator) {
        this.notify(this.$t('O_campo_Colaborador_é_obrigatório')+'.', 'red');
        return false;
      }
      if (!this.description) {
        this.notify(this.$t('O_campo_Motivo_é_obrigatório')+'.', 'red');
        return false;
      }
      if (this.description.length > 4000) {
        this.notify(
          this.$t('Passou_o_limite_de_caracteres_para_o_campo_Motivo')+'.',
          "red",
          7
        );
        return false;
      }

      this.$vs.loading();
      var that = this;

      const categoryId = this.category ? this.category.id : null;
      const year = this.year ? this.year.id : null;
      const quarter = this.quarter ? this.quarter.id : null;
      const month = this.month ? this.month.id : null;
      const personId = this.collaborator ? this.collaborator.cod_pessoa : null;

      this.$api({
        method: "post",
        url: "/human-resources/vg-star-nomination",
        headers: {
          Authorization: "Bearer " + this.$user.usertoken,
        },
        data: {
          category_id: categoryId,
          year: year,
          quarter: quarter,
          month: month,
          cod_person: personId,
          description: this.description,
        },
      })
        .then(function(res) {
          that.notify(that.$t('Nomeação_registada_com_sucesso')+'.', 'green');
          that.$router.push({ name: "vgstar" });
        })
        .catch(function(err) {
          that.notify(err.response.data.message, "red", 10);
        })
        .then(function() {
          that.$vs.loading.close();
        });

      this.formulario = false;
      this.clearInputs();
    },
    onSearch(search, loading) {
      if (parseInt(this.category.id) !== 1) {
        return;
      }
      this.goSearch = search;

      const categoryId = this.category ? parseInt(this.category.id) : null;
      const typeId = this.category ? parseInt(this.category.type_id) : null;
      const year = this.year ? parseInt(this.year.id) : null;
      const month = this.month ? parseInt(this.month.id) : null;

      if (search.length >= 3) {
        loading(true);

        var that = this;

        this.$api({
          method: "get",
          url: "/autocomplete/vg-star",
          headers: {
            Authorization: "Bearer " + this.$user.usertoken,
          },
          params: {
            search: search,
            category_id: categoryId,
            type_id: typeId,
            year: year,
            month: month,
          },
        })
          .then(function(response) {
            that.collaborators = response.data;
            that.found = that.collaborators.length;
          })
          .catch(function(err) {
            that.notify(err.response.data.message, "red", 10);
            that.found = 0;
          })
          .then(function() {
            loading(false);
          });
      }
    },
    goToForm() {
      this.formulario = true;
      this.clearInputs();
    },
    updateCategory() {
      this.quarter = null;
      this.month = null;
      this.collaborator = null;
      this.description = null;
      this.quarters = [];
      this.months = [];
      this.collaborators = [];
      this.getOptions(this.category.id, this.category.type_id);
    },
    updateYear() {
      const categoryId = parseInt(this.category.id);
      const year = parseInt(this.year.id);
      const quarter = this.quarter ? parseInt(this.quarter.id) : null;
      const month = this.month ? parseInt(this.month.id) : null;
      this.checkMyNominations(categoryId, year, quarter, month);
    },
    updateQuarter() {
      this.month = null;
      this.collaborator = null;
      this.description = null;
      this.months = [];
      this.collaborators = [];
      const categoryId = parseInt(this.category.id);
      const year = parseInt(this.year.id);
      const quarter = parseInt(this.quarter.id);
      this.checkMyNominations(categoryId, year, quarter, null);
    },
    updateMonth() {
      this.quarter = null;
      this.collaborator = null;
      this.description = null;
      this.quarters = [];
      this.collaborators = [];
      const categoryId = parseInt(this.category.id);
      const year = parseInt(this.year.id);
      const month = parseInt(this.month.id);
      this.checkMyNominations(categoryId, year, null, month);
    },
    getOptions(categoryId, typeId) {
      categoryId = parseInt(categoryId);
      typeId = parseInt(typeId);

      this.section_month = false;
      this.section_quarter = false;
      this.section_can_nominate = false;
      this.section_can_not_nominate = false;
      this.section_can_not_nominate_message = null;

      if (typeId === 1 || typeId === 2) {
        this.$api({
          method: "get",
          url: "/human-resources/vg-star-active-options-nomination",
          headers: {
            Authorization: "Bearer " + this.$user.usertoken,
          },
          params: {
            category_id: categoryId,
            type_id: typeId,
          },
        })
          .then((response) => {
            switch (typeId) {
              case 1:
                this.months = Object.entries(response.data).map(
                  ([key, value]) => ({ id: `${key}`, label: `${value}` })
                );
                this.section_month = true;
                this.quarter = null;
                break;
              case 2:
                this.quarters = Object.entries(response.data).map(
                  ([key, value]) => ({ id: `${key}`, label: `${value}` })
                );
                this.section_quarter = true;
                this.month = null;
                break;
            }
          })
          .catch((err) => {
            this.notify(err.response.data.message, "red", 10);
            this.$vs.loading.close();
          });
      } else {
        this.checkMyNominations(categoryId, this.year.id);
      }
    },
    clearInputs() {
      const currentYear = new Date().getFullYear();
      this.category = null;
      this.year = {
        id: currentYear,
        label: currentYear,
      };
      this.quarter = null;
      this.month = null;
      this.collaborator = null;
      this.description = null;
      this.quarters = [];
      this.months = [];
      this.collaborators = [];

      this.section_month = false;
      this.section_quarter = false;
      this.section_can_nominate = false;
      this.section_can_not_nominate = false;
      this.section_can_not_nominate_message = null;
    },
    checkMyNominations(categoryId, year, quarter = null, month = null) {
      var fields = {};
      fields.category_id = categoryId;
      fields.year = year;
      if (quarter) {
        fields.quarter = quarter;
      }
      if (month) {
        fields.month = month;
      }
      this.$api({
        method: "get",
        url: "/human-resources/vg-star-check-my-nominations",
        headers: {
          Authorization: "Bearer " + this.$user.usertoken,
        },
        params: fields,
      })
        .then((response) => {
          var result = null;
          var typeId = parseInt(response.data.type_id);
          if (response.data.can_nominate == 0) {
            switch (typeId) {
              case 1:
                result =
                  "A sua nomeação para o Vila Galé STAR Mensal de " +
                  this.getMonthName(month) +
                  " de " +
                  year +
                  " já foi registada.";
                break;
              case 2:
                result = "A sua nomeação para o Vila Galé STAR Trimestral do " + quarter + "º trimestre de " +
                year + " já foi registada.";
                break;
              case 3:
                result =
                  "A sua nomeação para o Vila Galé SUPERSTAR Hotel de " +
                  year +
                  " já foi registada.";
                break;
              case 4:
                result =
                  "A sua nomeação para o Vila Galé SUPERSTAR Nacional de " +
                  year +
                  " já foi registada.";
                break;
            }
            this.section_can_nominate = false;
            this.section_can_not_nominate = true;
            this.section_can_not_nominate_message = result;
          } else {
            this.section_can_not_nominate = false;
            this.section_can_not_nominate_message = null;
            if (typeId === 1) {
              this.section_can_nominate = true;
            } else {
              this.getcollaborators(categoryId, typeId, year, quarter, month);
            }
          }
        })
        .catch((err) => {
          this.notify(err.response.data.message, "red", 10);
          this.$vs.loading.close();
        });
    },
    getcollaborators(
      categoryId,
      typeId,
      year = null,
      quarter = null,
      month = null
    ) {
      this.$api({
        method: "get",
        url: "/human-resources/vg-star-collaborators",
        headers: {
          Authorization: "Bearer " + this.$user.usertoken,
        },
        params: {
          category_id: categoryId,
          type_id: typeId,
          year: year,
          quarter: quarter,
          month: month,
        },
      })
        .then((response) => {
          this.section_can_nominate = false;
          this.section_can_not_nominate = false;
          this.section_can_not_nominate_message = null;

          if (
            response.data.message_key &&
            response.data.message_key === "closed_nominations"
          ) {
            var result =
              "Os vencedores para a categoria selecionada já foram eleitos.";
            this.section_can_not_nominate = true;
            this.section_can_not_nominate_message = result;
          } else if (response.data.length === 0) {
            switch (typeId) {
              case 2:
                result =
                  "A votação para o Vila Galé STAR Trimestral do " +
                  quarter +
                  "º trimestre de " +
                  year +
                  " ainda não está disponível (vencedores do Vila Galé STAR Mensal por apurar).";
                break;
              case 3:
                result =
                  "A votação para o Vila Galé SUPERSTAR Hotel de " +
                  year +
                  " ainda não está disponível (vencedores Vila Galé STAR Trimestral por apurar).";
                break;
              case 4:
                result =
                  "A votação para o Vila Galé SUPERSTAR Nacional de " +
                  year +
                  " ainda não está disponível (vencedores Vila Galé SUPERSTAR Hotel por apurar).";
                break;
            }
            this.section_can_not_nominate = true;
            this.section_can_not_nominate_message = result;
          } else {
            this.collaborators = response.data;
            this.found = response.data.length;
            this.section_can_nominate = true;
          }
        })
        .catch((err) => {
          this.notify(err.response.data.message, "red", 10);
          this.$vs.loading.close();
        });
    },
    getMonthName: function(month) {
      var monthName = null;
      switch (month) {
        case 1:
          monthName = "Janeiro";
          break;
        case 2:
          monthName = "Fevereiro";
          break;
        case 3:
          monthName = "Março";
          break;
        case 4:
          monthName = "Abril";
          break;
        case 5:
          monthName = "Maio";
          break;
        case 6:
          monthName = "Junho";
          break;
        case 7:
          monthName = "Julho";
          break;
        case 8:
          monthName = "Agosto";
          break;
        case 9:
          monthName = "Setembro";
          break;
        case 10:
          monthName = "Outubro";
          break;
        case 11:
          monthName = "Novembro";
          break;
        case 12:
          monthName = "Dezembro";
          break;
      }
      return monthName;
    },
  },
  created() {
    this.init();
  },
  watch: {
    goSearch: function(valor) {
      if (valor == "") {
        this.collaborators = [];
        this.found = 0;
      }
    },
  },
  components: {},
};
</script>

<style scoped>
.BotaoVoltar {
  justify-content: flex-end;
}
.textarea {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  background-color: white;
}
.siteColor {
  color: #6ec9c2;
}
@media only screen and (max-width: 600px) {
  .mobileEnter {
    display: block;
  }
  .mobileCenter {
    margin-left: 60px !important;
  }
}
</style>
